import { InvoiceGenerationOptionEnum } from '~modules/connectors/constants/Invoice-generation.option';
import { DocumentRefOptionEnum, getDocumentRefOptions } from '~modules/connectors/constants/document-ref.option';
import { InvoiceAmountDifferenceOptionEnum } from '~modules/connectors/constants/invoice-amount-difference.option';
import { JournalOptionEnum } from '~modules/connectors/constants/journal.options';
import { ReverseChargeAggregateOptionEnum } from '~modules/connectors/constants/reverse-charge-aggregate.options';
import { AccountingEntriesFieldsConfiguration, DescriptionOption } from '~modules/connectors/services/extract-connectors-configurations/field-type';
import { bankEntryDescriptionDescriptionFieldOption, bankEntryLineDescriptionDescriptionFieldOption, buyInvoiceEntryDescriptionThirdPartFieldOption, buyInvoiceEntryLineDescriptionThirdPartFieldOption, clientThirdPartCounterpartTemplatingNameFieldOption, clientThirdPartyCounterpartTemplatingOptions, defaultGroupingDescriptionEmptyFieldOption, getBankEntryDescriptionFieldOptions, getBankEntryLineDescriptionFieldOptions, getBankGroupingDescriptionFieldOptions, getBuyInvoiceEntryDescriptionFieldOptions, getBuyInvoiceEntryLineDescriptionFieldOptions, getBuyInvoiceGroupingDescriptionFieldOptions, supplierThirdPartCounterpartTemplatingNameFieldOption, supplierThirdPartTemplatingNameFieldOption, supplierThirdPartyCounterpartTemplatingOptions, supplierThirdPartyTemplatingOptions } from './default-transformation-fields';

const zervantBankGroupingDescriptionOptions: DescriptionOption[] = getBankGroupingDescriptionFieldOptions();

const zervantBankEntryDescriptionOptions: DescriptionOption[] = getBankEntryDescriptionFieldOptions();

const zervantBankEntryLineDescriptionOptions: DescriptionOption[] = getBankEntryLineDescriptionFieldOptions();

const zervantBuyInvoiceGroupingDescriptionOptions: DescriptionOption[] = getBuyInvoiceGroupingDescriptionFieldOptions();

const zervantBuyInvoiceEntryDescriptionOptions: DescriptionOption[] = getBuyInvoiceEntryDescriptionFieldOptions({
    withThirdPart: true
});

const zervantBuyInvoiceEntryLineDescriptionOptions: DescriptionOption[] = getBuyInvoiceEntryLineDescriptionFieldOptions({
    withThirdPart: true
});

export const zervantTransformationFieldsConfiguration: AccountingEntriesFieldsConfiguration = {
    toolLabel: 'Zervant',

    buyInvoiceProcessorConfiguration: {
        journal: {
            code: {
                defaultValue: 'HA'
            },
            label: {
                defaultValue: 'Achats'
            }
        },
        thirdPartyAccount: {
            useSuggestedAccounts: {
                visible: false,
                defaultValue: false
            },
            account: {
                defaultValue: ''
            },
            label: {
                defaultValue: 'Fournisseurs'
            },
            isDynamic: {
                defaultValue: true
            },
            auxiliaryLabelStatic: {
                defaultValue: 'Fournisseurs'
            },
            auxiliaryAccountStatic: {
                defaultValue: 'FOURNISSEURS'
            },
            auxiliaryDynamic: {
                options: supplierThirdPartyTemplatingOptions,
                defaultOption: supplierThirdPartTemplatingNameFieldOption
            }
        },
        generation: {
            useSuggestedProductsAccounts: {
                defaultValue: true
            },
            option: {
                defaultWithSuggestedAccountValue: InvoiceGenerationOptionEnum.ONE_LINE_PER_PRODUCT_ACCOUNT,
                defaultWithoutSuggestedAccountValue: InvoiceGenerationOptionEnum.ONE_LINE_PER_INVOICE_LINE
            },
            oneLinePerInvoiceLine: {
                productVats: {
                    columns: {
                        countryCode: {
                            visible: false,
                            canEdit: false
                        },
                        regime: {
                            visible: false,
                            canEdit: false
                        }
                    },
                    defaultAccount: {
                        countryCode: null,
                        regime: null,
                        rate: null,
                        account: '471',
                        accountLabel: 'Charges à reclasser'
                    }
                }
            },
            oneGlobalLine: {
                product: {
                    account: {
                        defaultValue: '471'
                    },
                    label: {
                        defaultValue: 'Charges à reclasser'
                    }
                }
            }
        },
        useSuggestedVatsAccounts: {
            visible: false,
            defaultValue: false
        },
        collectedVats: {
            columns: {
                countryCode: {
                    visible: false,
                    canEdit: false
                },
                regime: {
                    visible: false,
                    canEdit: false
                }
            },
            defaultAccount: {
                countryCode: null,
                regime: null,
                rate: null,
                account: '44566',
                accountLabel: 'TVA à reclasser'
            }
        },
        amountDifferenceOption: {
            defaultValue: InvoiceAmountDifferenceOptionEnum.ADJUST_HT
        },
        debitAdjustment: {
            account: {
                defaultValue: "658"
            },
            label: {
                defaultValue: "Charges diverses de gestion courante"
            }
        },
        creditAdjustment: {
            account: {
                defaultValue: "758"
            },
            label: {
                defaultValue: "Produits divers de gestion courante"
            }
        },
        documentRef: {
            visible: false,
            options: getDocumentRefOptions(),
            defaultValue: DocumentRefOptionEnum.INVOICE_FUNCTIONAL_ID
        },
        groupingDescription: {
            visible: false,
            options: zervantBuyInvoiceGroupingDescriptionOptions,
            defaultOption: defaultGroupingDescriptionEmptyFieldOption
        },
        entryDescription: {
            options: zervantBuyInvoiceEntryDescriptionOptions,
            defaultOption: buyInvoiceEntryDescriptionThirdPartFieldOption
        },
        entryLineDescription: {
            options: zervantBuyInvoiceEntryLineDescriptionOptions,
            defaultOption: buyInvoiceEntryLineDescriptionThirdPartFieldOption
        }
    },

     bankProcessorConfiguration: {
            journalOption: {
                visible: false,
                defaultValue: JournalOptionEnum.BY_PAYMENT_METHOD,
            },
            uniqueJournal: {
                visible: false,
                code: {
                    defaultValue: 'BQ'
                },
                label: {
                    defaultValue: 'Zervant'
                }
            },
            client: {
                visible: false,
                useSuggestedAccounts: {
                    defaultValue: false
                },
                account: {
                    defaultValue: ''
                },
                label: {
                    defaultValue: 'Clients'
                },
                isDynamic: {
                    defaultValue: true
                },
                auxiliaryLabelStatic: {
                    defaultValue: 'Clients'
                },
                auxiliaryAccountStatic: {
                    defaultValue: 'CLIENTS'
                },
                auxiliaryDynamic: {
                    options: clientThirdPartyCounterpartTemplatingOptions,
                    defaultOption: clientThirdPartCounterpartTemplatingNameFieldOption
                }
            },
            supplier: {
                useSuggestedAccounts: {
                    visible: false,
                    defaultValue: false
                },
                account: {
                    defaultValue: ''
                },
                label: {
                    defaultValue: 'Fournisseurs'
                },
                isDynamic: {
                    defaultValue: true
                },
                auxiliaryLabelStatic: {
                    defaultValue: 'Fournisseurs'
                },
                auxiliaryAccountStatic: {
                    defaultValue: 'FOURNISSEURS'
                },
                auxiliaryDynamic: {
                    options: supplierThirdPartyCounterpartTemplatingOptions,
                    defaultOption: supplierThirdPartCounterpartTemplatingNameFieldOption
                }
            },
            useSuggestedProviderAccounts: {
                defaultValue: false
            },
            methods: {
                unique: false,
                columns: {
                    export: {
                        defaultValue: true
                    }
                },
                defaultMethod: {
                    name: null,
                    export: true,
                    journalCode: 'BQ',
                    internalTransfer: {
                        account: null,
                        label: null
                    },
                    provider: {
                        account: '51299',
                        label: null
                    }
                }
            },
            providerFee: {
                visible: false,
                account: {
                    defaultValue: '62781'
                },
                label: {
                    defaultValue: 'Autres frais et commissions sur prestations de services'
                }
            },
            deductibleVat20: {
                visible: false,
                account: {
                    defaultValue: '44566'
                },
                label: {
                    defaultValue: 'TVA sur autres biens et services'
                }
            },
            reverseCharge: {
                visible: false,
                has: {
                    defaultValue: false
                },
                aggregateOption: {
                    defaultValue: ReverseChargeAggregateOptionEnum.EACH
                },
                collectedIntracomVat: {
                    account: {
                        defaultValue: '4452'
                    },
                    label: {
                        defaultValue: 'TVA due intracommunautaire'
                    }
                },
                deductibleIntracomVat: {
                    account: {
                        defaultValue: '445662'
                    },
                    label: {
                        defaultValue: 'TVA intracommunautaire sur autres biens et services'
                    }
                },
                vatRate: {
                    defaultValue: 20
                }
            },
            useSuggestedCounterpartAccounts: {
                visible: false,
                defaultValue: false
            },
            undefinedCredit: {
                account: {
                    defaultValue: '471'
                },
                label: {
                    defaultValue: 'Opérations à reclasser'
                }
            },
            undefinedDebit: {
                account: {
                    defaultValue: '471'
                },
                label: {
                    defaultValue: 'Opérations à reclasser'
                }
            },
            groupingDescription: {
                visible: false,
                options: zervantBankGroupingDescriptionOptions,
                defaultOption: defaultGroupingDescriptionEmptyFieldOption
            },
            entryDescription: {
                options: zervantBankEntryDescriptionOptions,
                defaultOption: bankEntryDescriptionDescriptionFieldOption,
            },
            entryLineDescription: {
                options: zervantBankEntryLineDescriptionOptions,
                defaultOption: bankEntryLineDescriptionDescriptionFieldOption,
            }
        },
    
        analyticProcessorConfiguration: {
            isEnabled: {
                defaultValue: false
            },
            accountRules: {}
        }
    }